export default __webpack_public_path__ + "static/media/image1.ada91087.png";